function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_27917_30131)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 31.69L17.59 25.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.59 27.7L19.97 27.06L19.33 24.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.01 29.69L25.63 30.32L26.27 32.7",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.91 8.36C28.44 5.6 26.04 3.5 23.14 3.5C20.63 3.5 18.49 5.08 17.66 7.29C17.43 7.25 17.19 7.22 16.95 7.22C14.91 7.22 13.25 8.87 13.25 10.91C13.25 11.14 13.28 11.37 13.32 11.59C11.11 11.89 9.39999 13.78 9.39999 16.06C9.39999 18.56 11.43 20.58 13.93 20.58H27.97C31.37 20.58 34.13 17.83 34.13 14.43C34.13 11.35 31.86 8.81 28.9 8.36H28.91Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.66 7.28998C19.4 7.71998 20.43 9.14998 20.43 10.57",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.67 41.5C14.5257 41.5 16.03 39.9957 16.03 38.14C16.03 36.2844 14.5257 34.78 12.67 34.78C10.8143 34.78 9.31 36.2844 9.31 38.14C9.31 39.9957 10.8143 41.5 12.67 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.01 41.5C35.8657 41.5 37.37 39.9957 37.37 38.14C37.37 36.2844 35.8657 34.78 34.01 34.78C32.1543 34.78 30.65 36.2844 30.65 38.14C30.65 39.9957 32.1543 41.5 34.01 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.04 38.14H30.64",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7 26.16C14.45 26.26 14.2 26.38 13.96 26.51L8.87001 29.24L6.54001 29.53C5.80001 29.62 5.24001 30.25 5.24001 30.99V32.33C5.24001 32.7 5.15001 33.07 4.98001 33.4L4.75001 33.84C4.58001 34.17 4.49001 34.55 4.49001 34.92V35.93C4.49001 36.56 4.91001 37.12 5.52001 37.31L6.86001 37.71C7.82001 38 8.30001 38.15 9.30001 38.15",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.37 38.14H38.16L41.52 37.28C42.09 37.13 42.49 36.62 42.49 36.03V35.03C42.49 34.79 42.4 34.55 42.23 34.38L41.95 34.09C41.77 33.9 41.67 33.65 41.67 33.39V32.82C41.67 32.3 41.37 31.82 40.9 31.6C39.63 31 38.28 30.58 36.89 30.36L33.49 29.81L30.11 27.88",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 25.69L17.59 31.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.33 32.7L19.97 30.32L17.59 29.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.27 24.69L25.63 27.06L28.01 27.7",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.8 22.7V34.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.54 33.69L22.8 31.95L21.06 33.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.06 23.69L22.8 25.43L24.54 23.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_27917_30131"
}, /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  fill: "white",
  transform: "translate(4 3)"
})));
function SvgSnowy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowy);
export default __webpack_public_path__ + "static/media/snowy.18977f3454d84a644d501ad85666dc4c.svg";
export { ForwardRef as ReactComponent };